import React from 'react';
import { FiClock, FiShoppingCart } from 'react-icons/fi';
import './MealPlanToday.css';

const MealPlanToday = ({ mealPlan, onLogMeal, onViewFullPlan }) => {
  const getTodaysMeals = () => {
    if (!mealPlan || !mealPlan.meals) return [];

    const today = new Date().toLocaleDateString('en-US', { weekday: 'long' });
    const todaysMeals = mealPlan.meals[today] || {};

    return ['Breakfast', 'Lunch', 'Dinner', 'Snack 1', 'Snack 2']
      .map(mealType => ({
        type: mealType,
        foods: todaysMeals[mealType] || []
      }))
      .filter(meal => meal.foods.length > 0);
  };

  const calculateMealTotals = (foods) => {
    return foods.reduce(
      (acc, food) => ({
        calories: acc.calories + (food.totalCalories || 0),
        protein: acc.protein + (food.totalProtein || 0),
        carbs: acc.carbs + (food.totalCarbs || 0),
        fat: acc.fat + (food.totalFat || 0),
      }),
      { calories: 0, protein: 0, carbs: 0, fat: 0 }
    );
  };

  const getMealTime = (mealType) => {
    const times = {
      'Breakfast': '7:00 AM',
      'Snack 1': '10:00 AM',
      'Lunch': '12:30 PM',
      'Snack 2': '3:00 PM',
      'Dinner': '6:30 PM',
    };
    return times[mealType] || '';
  };

  const todaysMeals = getTodaysMeals();

  if (!mealPlan || todaysMeals.length === 0) {
    return (
      <div className="meal-plan-today-widget">
        <div className="widget-header">
          <h3>Today's Meal Plan</h3>
        </div>
        <div className="no-meal-plan">
          <p>No meal plan assigned yet</p>
          <span>Your trainer will assign a meal plan soon</span>
        </div>
      </div>
    );
  }

  return (
    <div className="meal-plan-today-widget">
      <div className="widget-header">
        <h3>Today's Meal Plan</h3>
        <button className="view-full-btn" onClick={onViewFullPlan}>
          View Week
        </button>
      </div>

      <div className="meals-list">
        {todaysMeals.map((meal) => {
          const totals = calculateMealTotals(meal.foods);
          return (
            <div key={meal.type} className="meal-card">
              <div className="meal-header">
                <div className="meal-info">
                  <span className="meal-type">{meal.type}</span>
                  <span className="meal-time">
                    <FiClock size={12} />
                    {getMealTime(meal.type)}
                  </span>
                </div>
                <button
                  className="log-meal-btn"
                  onClick={() => onLogMeal && onLogMeal(meal)}
                >
                  Log
                </button>
              </div>

              <div className="meal-foods">
                {meal.foods.map((food, index) => (
                  <div key={index} className="food-item">
                    <span className="food-name">{food.name}</span>
                    <span className="food-amount">
                      {food.servings}x {food.servingUnit || 'serving'}
                    </span>
                  </div>
                ))}
              </div>

              <div className="meal-totals">
                <span>{Math.round(totals.calories)} cal</span>
                <span>P: {Math.round(totals.protein)}g</span>
                <span>C: {Math.round(totals.carbs)}g</span>
                <span>F: {Math.round(totals.fat)}g</span>
              </div>
            </div>
          );
        })}
      </div>

      <button className="shopping-list-btn">
        <FiShoppingCart />
        Generate Shopping List
      </button>
    </div>
  );
};

export default MealPlanToday;
